import { Card, CardContent } from '@/components/ui/card';

const BookingDetails = ({ booking }) => {
  return (
    <Card>
      <CardContent className="p-4 space-y-6">
        <div>
          <h3 className="mb-2">Details</h3>
          <span className="text-sm text-muted-foreground">
            {booking.offeringDescription}
          </span>
        </div>
        {booking.offeringRequirements && (
          <div>
            <h3 className="mb-2">Requirements</h3>
            <span className="text-sm text-muted-foreground">
              {booking.offeringRequirements}
            </span>
          </div>
        )}
        {booking.offeringIncludedItems && (
          <div>
            <h3 className="mb-2">Included</h3>
            <span className="text-sm text-muted-foreground">
              {booking.offeringIncludedItems}
            </span>
          </div>
        )}
        {booking.offeringNotIncludedItems && (
          <div>
            <h3 className="mb-2">Not Included</h3>
            <span className="text-sm text-muted-foreground">
              {booking.offeringNotIncludedItems}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BookingDetails;
